import { Box, Stack } from '@mui/system';
import RoleDirectorySearchForm from './role-directory-search-form';
import { useQuery } from '@tanstack/react-query';
import { getAllRolesQuery } from '../../../../api/users-api';
import { useParams } from 'react-router-dom';
import { useUserSettings } from '../../../../utils/use-user-settings';

import Skeleton from '@mui/material/Skeleton';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

export default function RoleDirectorySearchPage() {
  const { roleName } = useParams() as { roleName: string };
  const { changeLogRoles } = useUserSettings();
  const { data: roles, isLoading } = useQuery(getAllRolesQuery());
  const currentRole = roles?.find((role) => role.roleName === roleName);

  if (isLoading || !currentRole) {
    return (
      <Box sx={{ position: 'relative', px: 2, pt: 2 }}>
        <Typography sx={{ fontSize: 24, textAlign: 'center', fontWeight: 400 }}>
          User Portal Directory Search
        </Typography>

        <Button
          variant="contained"
          disabled={true}
          sx={{ position: 'absolute', top: 0, right: 0 }}
        >
          Save
        </Button>
        <Typography sx={{ fontSize: 14, fontWeight: 300, marginTop: 2 }}>
          Orgs
        </Typography>
        <Stack
          sx={{
            px: 4,
          }}
        >
          <Skeleton variant="text" width={470} height={80} />
        </Stack>
      </Box>
    );
  }

  return (
    <RoleDirectorySearchForm
      role={currentRole}
      changeLogRoles={changeLogRoles}
    />
  );
}
